import { render, staticRenderFns } from "./OvVideo.vue?vue&type=template&id=09184479&"
import script from "./OvVideo.vue?vue&type=script&lang=js&"
export * from "./OvVideo.vue?vue&type=script&lang=js&"
import style0 from "./OvVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports